import api from "./api";

const studentService = {
  // GET /api/students?academicYear=&search=&page=&limit=&status=
  getAll: (params = {}) => api.get("/students", { params }),
  // GET /api/students/:id
  getById: (id) => api.get(`/students/${id}`),
  // GET /api/students/:id/certificates
  getCertificates: (id) => api.get(`/students/${id}/certificates`),
  // POST /api/students
  create: (data) => api.post("/students", data),
  // PUT /api/students/:id
  update: (id, data) => api.put(`/students/${id}`, data),
  // DELETE /api/students/:id
  remove: (id) => api.delete(`/students/${id}`),
  // PUT /api/students/batch-status
  batchStatus: (updates) => api.put("/students/batch-status", { updates }),
  // POST /api/students/import
  importStudents: (academicYear, students) =>
    api.post("/students/import", { academicYear, students }),
};

export default studentService;
